var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"on-boarding-dot"},_vm._l((_vm.dotClasses),function(dotClass,idx){return _c('div',{key:idx,class:dotClass})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }